import { render, staticRenderFns } from "./TempB.vue?vue&type=template&id=bd7d4d46&scoped=true&"
import script from "./TempB.vue?vue&type=script&lang=js&"
export * from "./TempB.vue?vue&type=script&lang=js&"
import style0 from "./TempB.vue?vue&type=style&index=0&id=bd7d4d46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7d4d46",
  null
  
)

export default component.exports